import { useSelector } from "react-redux";
import _ from 'lodash';

const ModulePermission = (moduleBridgeHex) => {
    const modulePermissions = useSelector(state => state.auth.permissions.modules);
    // if(!modulePermissions.indexOf(moduleBridgeHex)){
    const result = _.find(modulePermissions, (e) => e === moduleBridgeHex);
    if(!result){
        const rootProject = useSelector(state => state.global.urlData.rootProject);
        window.location.href = `${rootProject}login`
    }
    return null
};

export default ModulePermission;
